
//CONTA EMAIL
import ContaEmail from 'appsWeb/conta-email/index'

//CONTA WHATSAPP
import ContaWhatsapp from 'appsWeb/conta-whatsapp/index'

//PERIODICO
import Periodico from 'appsWeb/periodico/index'
import PeriodicoDesativado from 'appsWeb/periodico/desativado/index'

//LTCAT
import Ltcat from 'appsWeb/ltcat/index'
import LtcatCadastrar from 'appsWeb/ltcat/cadastrar'
import LtcatEditar from 'appsWeb/ltcat/editar'

import LtcatRisco from 'appsWeb/fator-risco/index'
import LtcatRiscoCadastrar from 'appsWeb/fator-risco/cadastrar'
import LtcatRiscoEditar from 'appsWeb/fator-risco/editar'

import LtcatLaboratorio from 'appsWeb/ltcat/laboratorio/index'
import LtcatLaboratorioEditar from 'appsWeb/ltcat/laboratorio/editar'
import LtcatLaboratorioCadastrar from 'appsWeb/ltcat/laboratorio/cadastrar'

import LtcatTabela from 'appsWeb/ltcat/tabela-dinamica/index'
import LtcatTabelaEditar from 'appsWeb/ltcat/tabela-dinamica/editar'
import LtcatTabelaCadastrar from 'appsWeb/ltcat/tabela-dinamica/cadastrar'

import LtcatConfiguracao from 'appsWeb/ltcat/configuracao/index'

//CONSULTA
import ConsultaLiberacao from 'appsWeb/consulta/liberacao/index'

//CONSULTA EXTERNA
import ConsultaExterna from 'appsWeb/consulta-externa/index'
import EmpresaFuncionarioAsoAssinar from '../components/apps/funcionario/aso/assinar/index.vue'

//ESOCIAL
import Esocial from 'appsWeb/esocial/index'
import EsocialCertificado from 'appsWeb/esocial/certificado/index'
import EsocialLotes from 'appsWeb/esocial/lotes/index'
import EsocialConfiguracao from 'appsWeb/esocial/configuracao/index'
import EsocialLotesDownload from 'appsWeb/esocial/lotes/download'
import oAuth2Callback from '../components/apps/web/conta-email/oAuth2Callback.vue'
import PrivacyPolicy from '../components/apps/web/Privacy-Policy/index.vue'




const routes = [
  {
    name: '404',
    path: '*',
    meta: { requiresAuth: false },
    component: () => import('apps/template/404'),
  },
  {
    path: '/',
    meta: { requiresAuth: false },
    component: () => import('layouts/index'),
    children: [
      {
        path: '/',
        meta: { requiresAuth: false },
        component: () => import('layouts/web'),
        children: [
          //LOGIN
          {
            path: '',
            meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
            component: () => import('appsWeb/login/index'),
          },
          {
            path: 'login',
            name: 'web.login',
            meta: { requiresAuth: false, disablePageHeader: true, title: 'Login', navigation: [] },
            component: () => import('appsWeb/login/index'),
          },
          {
            path: ':tenant/funcionario/aso/assinar/:idConsulta',
            name: 'web.funcionario.aso.assinar',
            component: EmpresaFuncionarioAsoAssinar,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Assinatura de ASO',
              navigation: []
            },
          },
          {
            path: ':tenant/funcionario/aso/assinar/:idConsulta/validacao/:step',
            name: 'web.funcionario.aso.assinar.step',
            component: EmpresaFuncionarioAsoAssinar,
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Assinatura de ASO',
              navigation: []
            },
          },
          {
            path: 'logout',
            name: 'logout',
            omponent: () => import('common/logout'),
            meta: {
              requiresAuth: false,
              disablePageHeader: true,
              title: 'Sair do Sistema',
              navigation: [
                { text: 'Sair do Sistema', active: true }
              ]
            },
          },
          //HOME
          {
            path: '',
            name: 'web.home',
            component: () => import('appsWeb/home/index'),
            meta: {
              requiresAuth: true,
              navigation: [
                { text: 'Home', active: false },
              ]
            },
          },
          //Privacy Policy

          {
            path: 'politica-de-privacidade',
            name: 'web.politica',
            component: () => import('appsWeb/Privacy-Policy/index'),
            meta: {
              requiresAuth: false,
              title:'',
            }
          },

          //OAuth2

          {
            path: 'conta-email/oauth2/iniciar',
            name: 'web.conta-email.oauth2.iniciar',
            beforeEnter(to, from, next) {
              // Faz a requisição para a API antes de entrar na rota
              fetch('https://www1.softwareatento.com.br/commtrol/api/conta-email/oauth2/iniciar')

              fetch('http://localhost:8070/api/conta-email/oauth2/iniciar')
                .then(res => res.json())
                .then(data => {
                  if (data.redirect_url) {
                    // Redireciona para a URL retornada pela API
                    window.location.href = data.redirect_url
                  } else {
                    console.error('redirect_url não encontrada na resposta da API.')
                    next(false) // cancela a navegação
                  }
                })
                .catch(err => {
                  console.error('Erro ao iniciar OAuth:', err)
                  next(false) // cancela a navegação em caso de erro
                })
            },
            meta: {
              requiresAuth: true,
              title: 'Conectar Conta de Email',
            },

          },
          //Rota de Callback do OAuth2
          {

          //Rota de Callback do OAuth2

            path: '/oauth2/callback',
            name: 'oAuth2Callback',
            component: () => import('../components/apps/web/conta-email/oAuth2Callback.vue'),

            meta: {
               title: 'OAuth2 Callback',   // evita _vm.$route.meta.title undefined
               requiresAuth: true,
            }

          },

          //ENVIA MENSAGEM PARA O CONTADOR
          {
            path: '/contador/:emp/:token',
            name: 'contador',
            component: () => import('appsWeb/Envio_Contador/CpfMatriculaForm.vue'),
            meta: {
              requiresAuth: false,
              title: '',
              navigation: []
            }
          },

          //EMPRESA
          {
            path: 'empresas',
            name: 'empresa',
            component: () => import('appsWeb/empresa/index'),
            meta: {
              requiresAuth: true,
              title: 'Empresas',
              navigation: [
                { text: 'Empresas', active: false, cs:true, to:'/app/empresas.php' },
              ]
            },
          },
          {
            path: 'empresas/cadastrar',
            name: 'empresa.cadastrar',
            component: () => import('appsWeb/empresa/cadastrar'),
            meta: {
              requiresAuth: true,
              title: 'Empresas',
              navigation: [
                { text: 'Empresas', active: false, to: '/empresas' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'empresas/editar/:id',
            name: 'empresa.editar',
            component: () => import('appsWeb/empresa/editar'),
            meta: {
              requiresAuth: true,
              title: 'Empresas',
              navigation: [
                { text: 'Empresas', active: false, to: '/empresas' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'empresa/tabela-balcao',
            name: 'empresa.tabelabalcao',
            component: () => import('appsWeb/empresa/tabela-preco-balcao/index'),
            meta: {
              requiresAuth: true,
              title: 'Empresas',
              navigation: [
                { text: 'Empresas', active: false, to: '/empresas' },
                { text: 'Tabela Preço Balcão', active: true },
              ]
            },
          },
          //CONSULTAS
          {
            path: 'consultas/liberacao',
            name: 'consultas.liberacao',
            component: ConsultaLiberacao,
            meta: {
              requiresAuth: true,
              title: 'Consultas',
              navigation: [
                { text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' },
                { text: 'Liberação', active: true },
              ]
            },
          },
          //CONSULTA EXTERNA
          {
            path: 'consultas/externas',
            name: 'consultas.externa',
            component: ConsultaExterna,
            meta: {
              requiresAuth: true,
              title: 'Consultas Externas',
              navigation: [
                { text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' },
                { text: 'Consulta Externa', active: true },
              ]
            },
          },
          //aproveitamento
          {
            path: 'consultas/aproveitamento',
            name: 'consultas.aproveitamento',
            component: () => import('appsWeb/consulta/aproveitamento/index'),
            meta: {
              requiresAuth: true,
              title: 'Aproveitamento de ASO',
              navigation: [
                { text: 'Consultas', active: false, cs: true, to: '/app/consultas.php' },
                { text: 'Aproveitamento de ASO', active: true },
              ]
            },
          },

          //CREDENCIADA
          {
            path: 'credenciadas',
            name: 'credenciada',
            component: () => import('appsWeb/credenciada/index'),
            meta: {
              requiresAuth: true,
              title: 'Credenciadas',
              navigation: [
                { text: 'Credenciadas', active: true },
              ]
            },
          },
          {
            path: 'credenciadas/cadastrar',
            name: 'credenciada.cadastrar',
            component: () => import('appsWeb/credenciada/cadastrar'),
            meta: {
              requiresAuth: true,
              title: 'Credenciadas',
              navigation: [
                { text: 'Credenciadas', active: false, to:'/credenciadas'},
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'credenciadas/editar/:id',
            name: 'credenciada.editar',
            component: () => import('appsWeb/credenciada/editar'),
            meta: {
              requiresAuth: true,
              title: 'Credenciadas',
              navigation: [
                { text: 'Credenciadas', active: false, to: '/credenciadas' },
                { text: 'Editar', active: true },
              ]
            },
          },

          //FINANCEIRO
          {
            path: 'financeiro/boleto/bradesco',
            name: 'financeiro.boleto.bradesco',
            component: () => import('appsWeb/financeiro/boleto/bradesco/index'),
            meta: {
              requiresAuth: true,
              title: 'Financeiro',
              navigation: [
                { text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' },
                { text: 'Boletos', active: true },
              ]
            },
          },
          {
            path: 'financeiro/boleto/inter',
            name: 'financeiro.boleto.inter',
            component: () => import('appsWeb/financeiro/boleto/inter/index'),
            meta: {
              requiresAuth: true,
              title: 'Financeiro',
              navigation: [
                { text: 'Financeiro', active: false, cs: true, to: '/app/fin_boletos.php' },
                { text: 'Boletos', active: true },
              ]
            },
          },

           //CAT
           {
            path: 'cat',
            name: 'cat',
            component: () => import('appsWeb/cat/index'),
            meta: {
              requiresAuth: true,
              title: 'Comunicação de Acidente de Trabalho',
              navigation: [
                { text: 'Comunicação de Acidente de Trabalho', active: true }
              ]
            },
          },
          {
            path: 'cat/modelo',
            name: 'cat.modelo',
            component: () => import('appsWeb/cat/modelo'),
            meta: {
              requiresAuth: true,
              title: 'Comunicação de Acidente de Trabalho',
              navigation: [
                { text: 'Comunicação de Acidente de Trabalho', active: false,to: '/cat' },
                { text: 'Modelo', active: true }
              ]
            },
          },

          //PCMSO
          {
            path: 'pcmso/vencido',
            name: 'pcmso.vencido',
            component: () => import('appsWeb/pcmso/vencido'),
            meta: {
              requiresAuth: true,
              title: 'PCMSO Vencido',
              navigation: [
                { text: 'PCMSO Vencido', active: true }
              ]
            },
          },
          {
            path: 'pcmso/disparador',
            name: 'pcmso.disparo',
            component: () => import('appsWeb/pcmso/disparo/index'),
            meta: {
              requiresAuth: true,
              title: 'Disparador',
              navigation: [
                { text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' },
                { text: 'Disparador', active: true },
              ]
            },
          },
          {
            path: 'pcmso/disparador/cadastrar',
            name: 'pcmso.disparo.cadastrar',
            component: () => import('appsWeb/pcmso/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' },
                { text: 'Disparador', active: false, to: '/pcmso/disparador'  },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'pcmso/disparador/editar/:id',
            name: 'pcmso.disparo.editar',
            component: () => import('appsWeb/pcmso/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'PCMSO VENCIDO', active: false, to: '/pcmso/vencido' },
                { text: 'Disparador', active: false, to: '/pcmso/disparador' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'pcmso/config',
            name: 'pcmso.config',
            component: () => import('appsWeb/pcmso/configuracao/index'),
            meta: {
              requiresAuth: true,
              title: 'Configuração',
              navigation: [
                { text: 'PCMSO', active: false, cs: true, to: '/app/pcmso.php' },
                { text: 'Configuração', active: true },
              ]
            },
          },
          //PPRA
          {
            path: 'ppra/vencido',
            name: 'ppra.vencido',
            component: () => import('appsWeb/pcmso/vencido'),
            meta: {
              requiresAuth: true,
              title: 'PPRA Vencido',
              navigation: [
                { text: 'PPRA Vencido', active: true }
              ]
            },
          },
          {
            path: 'ppra/disparador',
            name: 'ppra.disparo',
            component: () => import('appsWeb/ppra/disparo/index'),
            meta: {
              requiresAuth: true,
              title: 'Disparador',
              navigation: [
                { text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' },
                { text: 'Disparador', active: true },
              ]
            },
          },
          {
            path: 'ppra/disparador/cadastrar',
            name: 'ppra.disparo.cadastrar',
            component: () => import('appsWeb/ppra/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' },
                { text: 'Disparador', active: false, to: '/ppra/disparador'  },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'ppra/disparador/editar/:id',
            name: 'ppra.disparo.editar',
            component: () => import('appsWeb/ppra/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'PPRA VENCIDO', active: false, to: '/ppra/vencido' },
                { text: 'Disparador', active: false, to: '/ppra/disparador' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'ppra/config',
            name: 'ppra.config',
            component: () => import('appsWeb/pcmso/configuracao/index'),
            meta: {
              requiresAuth: true,
              title: 'Configuração',
              navigation: [
                { text: 'PPRA', active: false, cs: true, to: '/app/ppra.php' },
                { text: 'Configuração', active: true },
              ]
            },
          },
          //FUNCAO
          {
            path: 'config/funcoes',
            name: 'funcao',
            component: () => import('appsWeb/funcao/index'),
            meta: {
              requiresAuth: true,
              title: 'Funções',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Funções', active: true },
              ]
            },
          },

          //EXAME
          {
            path: 'config/exames',
            name: 'exame',
            component: () => import('appsWeb/exame/index'),
            meta: {
              requiresAuth: true,
              title: 'Exames',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Exames', active: true },
              ]
            },
          },
          //RISCO
          {
            path: 'config/riscos',
            name: 'risco',
            component: () => import('appsWeb/risco/index'),
            meta: {
              requiresAuth: true,
              title: 'Riscos',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Riscos', active: true },
              ]
            },
          },
          //CONTA EMAIL
          {
            path: 'config/conta-email',
            name: 'contaemail',
            component: ContaEmail,
            meta: {
              requiresAuth: true,
              title: 'Contas de Emails',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Contas de Emails', active: true },
              ]
            },
          },

          //CONTA WHATSAPP
          {
            path: 'config/conta-whatsapp',
            name: 'contawhatsapp',
            component: ContaWhatsapp,
            meta: {
              requiresAuth: true,
              title: 'Contas de WhatsApp',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Contas de WhatsApp', active: true },
              ]
            },
          },

          //PERIODICO
          {
            path: 'periodicos',
            name: 'periodico',
            component: Periodico,
            meta: {
              requiresAuth: true,
              title: 'Periódicos',
              navigation: [
                { text: 'Periódicos', active: true },
              ]
            },
          },
          {
            path: 'periodicos/disparador',
            name: 'periodico.disparo',
            component: () => import('appsWeb/periodico/disparo/index'),
            meta: {
              requiresAuth: true,
              title: 'Disparador',
              navigation: [
                { text: 'Periódicos', active: false, to: '/periodicos' },
                { text: 'Disparador', active: true },
              ]
            },
          },
          {
            path: 'periodicos/disparador/cadastrar',
            name: 'periodico.disparo.cadastrar',
            component: () => import('appsWeb/periodico/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'Periódicos', active: false, to: '/periodicos' },
                { text: 'Disparador', active: false, to: '/periodicos/disparador'  },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'periodicos/disparador/editar/:id',
            name: 'periodico.disparo.editar',
            component: () => import('appsWeb/periodico/disparo/editar'),
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'Periódicos', active: false, to: '/periodicos' },
                { text: 'Disparador', active: false, to: '/periodicos/disparador' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'periodicos/desativados',
            name: 'periodico.desativado',
            component: PeriodicoDesativado,
            meta: {
              requiresAuth: true,
              title: 'Desativados',
              navigation: [
                { text: 'Periódicos', active: false, to: '/periodicos' },
                { text: 'Desativados', active: true},
              ]
            },
          },
          //LTCAT
          {
            path: 'ltcat',
            name: 'ltcat',
            component: Ltcat,
            meta: {
              requiresAuth: true,
              title: 'LTCAT',
              navigation: [
                { text: 'LTCAT', active: true },
              ]
            },
          },
          {
            path: 'ltcat/cadastrar',
            name: 'ltcat.cadastrar',
            component: LtcatCadastrar,
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/editar/:id',
            name: 'ltcat.editar',
            component: LtcatEditar,
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/fator-risco',
            name: 'ltcat.risco',
            component: LtcatRisco,
            meta: {
              requiresAuth: true,
              title: 'Fator de Risco',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Fator de Risco', active: true },
              ]
            },
          },
          {
            path: 'ltcat/fator-risco/cadastrar',
            name: 'ltcat.risco.cadastrar',
            component: LtcatRiscoCadastrar,
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/fator-risco/editar/:id',
            name: 'ltcat.risco.editar',
            component: LtcatRiscoEditar,
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Fator de Risco', active: false, to: '/ltcat/fator-risco' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/modelo',
            name: 'ltcat.modelo',
            meta: {
              requiresAuth: true,
              title: 'Modelos',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Modelos', active: true },
              ]
            },
          },
          {
            path: 'ltcat/laboratorio',
            name: 'ltcat.laboratorio',
            component: LtcatLaboratorio,
            meta: {
              requiresAuth: true,
              title: 'Laboratórios',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Laboratórios', active: true },
              ]
            },
          },
          {
            path: 'ltcat/laboratorio/cadastrar',
            name: 'ltcat.laboratorio.cadastrar',
            component: LtcatLaboratorioCadastrar,
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/laboratorio/editar/:id',
            name: 'ltcat.laboratorio.editar',
            component: LtcatLaboratorioEditar,
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Laboratórios', active: false, to: '/ltcat/laboratorio' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/tabela-dinamica',
            name: 'ltcat.tabela',
            component: LtcatTabela,
            meta: {
              requiresAuth: true,
              title: 'Tabela Dinâmica',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Tabela Dinâmica', active: true },
              ]
            },
          },
          {
            path: 'ltcat/tabela-dinamica/cadastrar',
            name: 'ltcat.tabela.cadastrar',
            component: LtcatTabelaCadastrar,
            meta: {
              requiresAuth: true,
              title: 'Cadastrar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/tabela-dinamica/editar/:id',
            name: 'ltcat.tabela.editar',
            component: LtcatTabelaEditar,
            meta: {
              requiresAuth: true,
              title: 'Editar',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Tabela Dinâmica', active: false, to: '/ltcat/tabela-dinamica' },
                { text: 'Editar', active: true },
              ]
            },
          },
          {
            path: 'ltcat/configuracao',
            name: 'ltcat.configuracao',
            component: LtcatConfiguracao,
            meta: {
              requiresAuth: true,
              title: 'Configurações',
              navigation: [
                { text: 'LTCAT', active: false, to: '/ltcat' },
                { text: 'Configurações', active: false }
              ]
            },
          },
          //PGR
          {
            path: 'pgr',
            name: 'pgr',
            component: () => import('appsWeb/pgr/index'),
            meta: {
              requiresAuth: true,
              title: 'PGR',
              navigation: [
                { text: 'PGR', active: true },
              ]
            },
          },
          {
            path: 'pgr/cadastrar',
            name: 'pgr.cadastrar',
            component: () => import('appsWeb/pgr/cadastrar'),
            meta: {
              requiresAuth: true,
              title: 'PGR',
              navigation: [
                { text: 'PGR', active: false,to: '/pgr' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'pgr/editar/:id',
            name: 'pgr.editar',
            component: () => import('appsWeb/pgr/editar'),
            meta: {
              requiresAuth: true,
              title: 'PGR',
              navigation: [
                { text: 'PGR', active: false,to: '/pgr' },
                { text: 'Editar', active: true },
              ]
            },
          },

          //RELATORIO
          {
            path: 'relatorio/anual',
            name: 'relatorio.anual',
            component: () => import('appsWeb/relatorio/anual/index'),
            meta: {
              requiresAuth: true,
              title: 'Relatório Analítico',
              navigation: [
                { text: 'Relatório Analítico', active: true, to: '/relatorio/anual' },
              ]
            },
          },
          //PROFISSIONAIS
          {
            path: 'config/profissionais',
            name: 'profissionais',
            component: () => import('appsWeb/profissionais/index'),
            meta: {
              requiresAuth: true,
              title: 'Profissionais Responsáveis',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Profissionais Responsáveis', active: true },
              ]
            },
          },
          //PARCEIROS
          {
            path: 'config/parceiros',
            name: 'parceiro',
            component: () => import('appsWeb/parceiro/index'),
            meta: {
              requiresAuth: true,
              title: 'Parceiros',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Parceiros', active: true },
              ]
            },
          },
          {
            path: 'config/parceiros/cadastrar',
            name: 'parceiro.cadastrar',
            component: () => import('appsWeb/parceiro/cadastrar'),
            meta: {
              requiresAuth: true,
              title: 'Parceiros',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Parceiros', active: true, to: '/config/parceiros' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'config/parceiros/editar/:id',
            name: 'parceiro.editar',
            component: () => import('appsWeb/parceiro/editar'),
            meta: {
              requiresAuth: true,
              title: 'Parceiros',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Parceiros', active: true, to: '/config/parceiros' },
                { text: 'Editar', active: true },
              ]
            },
          },
          //MEDICOS
          {
            path: 'config/medicos',
            name: 'medico',
            component: () => import('appsWeb/medico/index'),
            meta: {
              requiresAuth: true,
              title: 'Medicos Examinadores',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Medicos Examinadores', active: true },
              ]
            },
          },
          {
            path: 'config/medicos/cadastrar',
            name: 'medico.cadastrar',
            component: () => import('appsWeb/medico/cadastrar'),
            meta: {
              requiresAuth: true,
              title: 'Medicos Examinadores',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Medicos Examinadores', active: true, to: '/config/medicos' },
                { text: 'Cadastrar', active: true },
              ]
            },
          },
          {
            path: 'config/medicos/editar/:id',
            name: 'medico.editar',
            component: () => import('appsWeb/medico/editar'),
            meta: {
              requiresAuth: true,
              title: 'Medicos Examinadores',
              navigation: [
                { text: 'Configurações', active: false, cs: true, to: '/app/vc_mc.php' },
                { text: 'Medicos Examinadores', active: true, to: '/config/medicos' },
                { text: 'Editar', active: true },
              ]
            },
          },
          //LOG
          {
            path: 'log/tarefa',
            name: 'log.tarefa',
            component: () => import('appsWeb/log/tarefa/index'),
            meta: {
              requiresAuth: true,
              title: 'Tarefa',
              navigation: [
                { text: 'Log', active: false },
                { text: 'Tarefa', active: true },
              ]
            },
          },
          {
            path: 'log/aplicacao',
            name: 'log.aplicacao',
            component: () => import('appsWeb/log/aplicacao/index'),
            meta: {
              requiresAuth: true,
              title: 'Logs da Aplicação',
              navigation: [
                { text: 'Log', active: false },
                { text: 'Logs da Aplicação', active: true },
              ]
            },
          },

          //ESOCIAL
          {
            path: 'esocial',
            name: 'esocial',
            component: Esocial,
            meta: {
              requiresAuth: true,
              title: 'Esocial',
              navigation: [
                { text: 'Esocial', active: false},
              ]
            },
          },
          {
            path: 'esocial/avulso',
            name: 'esocial.avulso',
            component: () => import('appsWeb/esocial/avulso'),
            meta: {
              requiresAuth: true,
              title: 'Esocial Avulso',
              navigation: [
                { text: 'Esocial Avulso', active: false},
              ]
            },
          },
          {
            path: 'esocial/lotes/:lote?',
            name: 'esocial.lotes',
            component: EsocialLotes,
            meta: {
              requiresAuth: true,
              title: 'Lotes',
              navigation: [
                { text: 'Esocial', active: false, to: '/esocial' },
                { text: 'Lotes', active: true },
              ]
            },
          },
          {
            path: 'esocial/certificados',
            name: 'esocial.certificado',
            component: EsocialCertificado,
            meta: {
              requiresAuth: true,
              title: 'Certificados',
              navigation: [
                { text: 'Esocial', active: false, to: '/esocial' },
                { text: 'Certificados', active: true },
              ]
            },
          },
          {
            path: 'esocial/configuracao',
            name: 'esocial.configuracao',
            component: EsocialConfiguracao,
            meta: {
              requiresAuth: true,
              title: 'Configuração',
              navigation: [
                { text: 'Esocial', active: false, to: '/esocial' },
                { text: 'Configuração', active: true },
              ]
            },
          },
        ]
      },
    ]
  }

]

export default routes



// WEBPACK FOOTER //
// ./src/router/web.js